// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"08460720","453":"7681d562","732":"a3813a16"}[chunkId] + ".chunk.js";
};